import React from 'react';
import { Form, Button, InputGroup } from 'react-bootstrap';
import SearchableDropdown from './SearchableDropdown';

/**
 * Read-only input + optional clear (×) button + SearchableDropdown.
 * Use when the user picks from a list and can clear the selection.
 */
const ClearableDropdownField = React.forwardRef(({
  value,
  placeholder,
  disabled,
  loading,
  loadingMessage = 'Loading...',
  showDropdown,
  options,
  emptyMessage,
  getLabel,
  getItemKey,
  onSelect,
  onFocus,
  onClick,
  onClear,
  hasValue,
  id,
  clearTitle = 'Clear'
}, ref) => (
  <div ref={ref} className="position-relative">
    <InputGroup>
      <Form.Control
        type="text"
        readOnly
        autoComplete="off"
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        onFocus={onFocus}
        onClick={onClick}
        aria-expanded={showDropdown}
        aria-controls={id}
      />
      {hasValue && onClear && (
        <Button variant="outline-secondary" onClick={onClear} title={clearTitle}>×</Button>
      )}
    </InputGroup>
    {loading && <Form.Text className="text-muted">{loadingMessage}</Form.Text>}
    {showDropdown && !loading && (
      <SearchableDropdown
        options={options}
        emptyMessage={emptyMessage}
        onSelect={onSelect}
        getLabel={getLabel}
        id={id}
        getItemKey={getItemKey}
      />
    )}
  </div>
));

ClearableDropdownField.displayName = 'ClearableDropdownField';

export default ClearableDropdownField;
